const useHtmlClass = ()  => {
    const htmlTag = document.documentElement

    const add = className => {
        htmlTag.classList.add(className)
    }

    const remove = className => {
        if(htmlTag.classList.contains(className)) {
            htmlTag.classList.remove(className)
        }
    }

    return [add, remove]
}

export default useHtmlClass